import React from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from '~/shared/components/Button'

import { StyledModal as S } from './Modal.styles'

type TProps = {
  isShown: boolean
  onClose: () => void
  children?: React.ReactNode
}

export const Modal: React.FC<TProps> = ({ isShown, onClose, children }) => {
  const { t } = useTranslation()

  return isShown ? (
    <S.Wrapper>
      <S.Content>
        <S.Text>{children}</S.Text>
        <Button type="button" onClick={onClose}>
          {t`actions.ok`}
        </Button>
      </S.Content>
    </S.Wrapper>
  ) : null
}
